import { StyleSheet as PDFStyleSheet } from '@react-pdf/renderer'

const styles = PDFStyleSheet.create({
  main: {
    width: '90%',
    alignItems: 'flex-end',
    borderWidth: 1,
    borderRadius: 8,
    borderColor: '#dbdbdb',
    marginTop: 26,
    marginBottom: 20
  },
  titleContainer: {
    flexDirection: 'row',
    right: 0,
    top: -20
  },
  mainTitle: {
    fontSize: 10
  },
  mainDiv: {
    width: '100%',
    marginTop: -12,
    borderStyle: 'solid',
    borderColor: '#dbdbdb',
    textAlign: 'right',
    direction: 'rtl',
    padding: 8
  },
  title: {
    fontSize: 8,
    lineHeight: 1.6,
    color: 'black',
    textAlign: 'right',
    direction: 'rtl'
  }
})

export default styles
